import ListView from "../listViews/listView";
import BuilderModel from "./builderModel";

export default class ListViewBuilderModel extends BuilderModel {
  listView: ListView;
  except = ['listView', 'createEmbeddedObject'];
}
